// import {Message} from 'element-ui'
import {MessageBox} from 'element-ui'
function msgWarning (message, title = '错误', big = false,type = 0) {
  if (Object.prototype.toString.call(message).indexOf('Error') > -1) {
    message = message.message
  }
  if(type === 1 && message.includes('创建失败')) message = addBreakTags(message, '创建失败');
  // console.error(message)
  let otherClass = ''
  if (big) otherClass = 'big-warning'
  MessageBox.alert(message, title, {
    showConfirmButton: false,
    // closeOnClickModal: true,
    closeOnPressEscape: true,
    customClass: 'msgWarning' + (big ? ' ' + otherClass : ''),
    dangerouslyUseHTMLString: true // 允许html
  })
}

// 错误换行
function addBreakTags(text, matchText) {
  const escapedMatchText = matchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // 转义匹配文本中的特殊字符
  const regex = new RegExp(escapedMatchText, 'g'); // 创建全局正则表达式
  return text.replace(regex, `<br>${matchText}`); // 替换匹配的文本
}

export default msgWarning

// import msgWarning from '@/tools/msgwarning.js'
// msgWarning()
// msgWarning(res.desc)



// WEBPACK FOOTER //
// ./src/tools/msgwarning.js